import {Aktualita} from "../../src/interfaces/interfaces";

const aktuality : Aktualita[] = [
        {
                title: 'Zveme malá šikovná děvčátka vyzkoušet si trénink moderní gymnastiky.',
                PDFtitle: '',
                PDF: ''
        },
        {
                title: 'Nestihli jste talentové zkoušky? Nevadí. Přijďte se podívat přímo na trénink.',
                PDFtitle: '',
                PDF: '',
                link: 'https://docs.google.com/forms/d/e/1FAIpQLScsdljfQHb6UHLs3CErXOExS5FvvLi11veAfXBdvuuCCZBNYg/viewform',
                linkTitle: 'Vyplnit nezávaznou přihlášku'
        },
       
]

export const aktualityImage  = "talentovky leták 2026.jpg";         // jmeno souboru i s příponou, který vložíš do /obrazky/akuality

export default aktuality
